import { create } from "zustand";
import { persist } from "zustand/middleware";

export type ThemeMode =
  | "dark"
  | "light"
  | "high-contrast-dark"
  | "high-contrast-light";

interface ThemeState {
  theme: ThemeMode;
  setTheme: (theme: ThemeMode) => void;
}

export const useThemeStore = create<ThemeState>()(
  persist(
    (set) => ({
      theme: "dark",
      setTheme: (theme) => {
        set({ theme });
        applyTheme(theme);
      },
    }),
    {
      name: "quanta-theme",
      onRehydrateStorage: () => (state) => {
        // Apply theme on app load
        if (state?.theme) {
          applyTheme(state.theme);
        }
      },
    },
  ),
);

function applyTheme(theme: ThemeMode) {
  document.documentElement.setAttribute("data-theme", theme);
}

// Theme labels for UI
export const themeLabels: Record<ThemeMode, string> = {
  dark: "Dark",
  light: "Light",
  "high-contrast-dark": "High Contrast Dark",
  "high-contrast-light": "High Contrast Light",
};

// Theme descriptions for accessibility
export const themeDescriptions: Record<ThemeMode, string> = {
  dark: "Dark space theme with purple accents",
  light: "Light theme for bright environments",
  "high-contrast-dark": "High contrast dark theme for improved visibility",
  "high-contrast-light": "High contrast light theme for improved visibility",
};
